/**
 * @generated SignedSource<<6afff10ccfcc95c16be78364b6942b13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrainSearchSidebarList_ItemFragment$data = {
  readonly createdAt: string;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchMoreActionsButtonFragment">;
  readonly " $fragmentType": "BrainSearchSidebarList_ItemFragment";
};
export type BrainSearchSidebarList_ItemFragment$key = {
  readonly " $data"?: BrainSearchSidebarList_ItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrainSearchSidebarList_ItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrainSearchSidebarList_ItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BrainSearchMoreActionsButtonFragment"
    }
  ],
  "type": "BrainSearch",
  "abstractKey": null
};

(node as any).hash = "24da947ad6a0377ab82a59bc609298f7";

export default node;
